import * as React from "react"
import {Box} from "@mui/material"
import {translateCountryName} from "@ui-seeker/utils";

import {LabelCountry} from "@components"


export default function retailerColumn() {
	return [{
		name: 'country',
		label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v),
		}
	}, {
		name: 'retailer', label: 'Retailer',
		options: {
			customBodyRowRender: (value, { country, siteURL }) => {
				return <Box sx={{ display: 'flex', justifyContent: 'center' }}>
					<LabelCountry
						country={country}
						label={value}
						siteUrl={siteURL}
						sx={{svg: {verticalAlign: 'middle'}}}
					/>
				</Box>
			}
		}
	}]
}